<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso",
    @solicitacaoEnviada="solicitacaoEnviada"
  )
  app-modal-solicitar-acesso(
    v-if="showModalSolicitarAcesso",
    :idsProcessosSelecionados="processoEscolhido",
    :idSolicitacao="idSolicitacao",
    @closeModal="showModalSolicitarAcesso = false",
    @limpar="limpar",
    @solicitacaoEnviada="refreshInformacoes"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisarInformacoes",
      @limpar="clearInformacoes",
      :showOs="true",
      :configuracaoFiltro="configuracaoFiltro",
      :showfiltrosInformacoes="true",
      :showPesquisaAvancada="false",
      :placeholder="'Informe o nome do responsável ou numero do processo'"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    @updateListagem="refreshInformacoes",
    @executar="executar",
    @changePage="changePage",
    @selected="false"
  )
  app-modal-notificar-interessado(
    v-if="modalMensagens",
    :idProcesso="idProcesso",
    :isSolicitacao="true",
    @closeModal="closeModalNotificarInteressado"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import { mapActions } from 'vuex'
import Filtro from '@/screens/analise/listagem/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import AppModalSolicitarAcesso from './components/AppModalSolicitarAcesso.vue'
import AppModalNotificarInteressado from '../analise/components/modal/AppModalNotificarInteressado.vue'
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default

export default {
  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    AppModalSolicitarAcesso,
    AppModalNotificarInteressado
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_SOLICITACOES'),
      items: [],
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      totalElements: 0,
      infoPrazos: undefined,
      usuario: null,
      showModalSolicitarAcesso: false,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {},
      processoEscolhido: [],
      idSolicitacao: null,
      modalMensagens: false,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Nome/Razão social', propriedade: 'interessadoNomeRazaoSocial', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Data Solicitação', propriedade: 'dataChegada', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipios', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'statusSolicitacaoAcesso', ordem: 6, acoes: [] },
        { id: 6, titulo: 'Data de autorização', propriedade: 'dataAutorizacao', ordem: 7, acoes: [] },
        { id: 7, titulo: 'Data limite acesso', propriedade: 'dataLimiteAcesso', ordem: 8, acoes: [] },
        { id: 8,
          titulo: 'Ações',
          propriedade: 'tipo',
          ordem: 9,
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVizualizarProcessoCaixaSolicitacao },
            { id: 2, nome: 'Solicitar Acesso', icone: 'fa-edit', codigo: 'SOLICITAR_ACESSO', ordem: 2, show: this.showSolicitarAcesso },
            { id: 3, nome: 'Mensagens', icone: 'fa-envelope', codigo: 'VISUALIZAR_MENSAGENS', ordem: 3, show: this.showMensagens }
          ]
        }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false
    }
  },

  async created () {
    this.usuario = await this.getUsuario()
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario',
      conversaByProcessoId: 'conversa/conversaByProcessoId'
    }),
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario.perfilSelecionado.codigo) !== undefined
    },
    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    closeModalNotificarInteressado () {
      this.modalMensagens = false
    },
    solicitacaoEnviada () {
      this.showModalVisualizarProcesso = false
      this.modalMensagens = true
      this.refreshInformacoes()
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.idProcesso
      this.numeroProcesso = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    SOLICITAR_ACESSO (_this, {item}) {
      this.showModalSolicitarAcesso = true
      this.processoEscolhido.push(item.idProcesso)
      this.idSolicitacao = item.id
    },
    VISUALIZAR_MENSAGENS (_this, {item}) {
      this.idProcesso = item.idProcesso
      this.modalMensagens = true
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/acompanharProcessos/CaixaSolicitacoes.vue